import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'chat-audio',
  templateUrl: './chat-audio.component.html',
  styleUrls: ['./chat-audio.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ChatAudioComponent implements OnInit {

  @Output() aoGravar = new EventEmitter<File>();
  @Output() inicioGravacao = new EventEmitter<boolean>();
  @Output() fimGravacao = new EventEmitter<boolean>();
  @Input() disabled: boolean = false;

  public gravando = false;
  private mediaRecorder: MediaRecorder | null = null;
  private chunks: BlobPart[] = [];
  private stream: MediaStream | null = null;

  public audioURL: SafeUrl | null = null;
  private audioBlob: Blob | null = null;
  private audioFile: File | null = null;

  private _enviarAoParar = false;

  public tempoGravacao: string = '0:00';
  private intervalTimer: any = null;
  private segundos = 0;

  constructor(  private zone: NgZone,
  private cdr: ChangeDetectorRef,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  async iniciarGravacao(): Promise<void> {
    
    if (this.disabled) return;
    this.inicioGravacao.emit(true);
    if (this.gravando) {
      this.pararGravacao();
      return;
    }

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(this.stream);
      this.chunks = [];

      this.segundos = 0;
      this.tempoGravacao = '0:00';
      this.iniciarTimer();

      this.mediaRecorder.ondataavailable = e => this.chunks.push(e.data);
      this.mediaRecorder.onstop = () => {
        this.pararTimer();

        this.audioBlob = new Blob(this.chunks, { type: 'audio/ogg; codecs=opus' });
        this.audioFile = new File([this.audioBlob], `gravacao-${Date.now()}.ogg`, { type: this.audioBlob.type });
        this.audioURL = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.audioBlob));

        if (this._enviarAoParar && this.audioFile) {
          this.aoGravar.emit(this.audioFile);
          this._enviarAoParar = false;
          this.resetar(true);
          return;
        }

        this.gravando = false;
        this.stream?.getTracks().forEach(track => track.stop());
      };

      this.mediaRecorder.start();
      this.gravando = true;
    } catch (err) {
      console.error('Erro ao acessar microfone:', err);
    }
  }

private iniciarTimer() {
  this.pararTimer();
  this.intervalTimer = setInterval(() => {
    this.zone.run(() => {
      this.segundos++;
      const m = Math.floor(this.segundos / 60);
      const s = this.segundos % 60;
      this.tempoGravacao = `${m}:${s.toString().padStart(2, '0')}`;

      this.cdr.markForCheck();
    });
  }, 1000);
}

  private pararTimer() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
      this.intervalTimer = null;
    }
  }

  finalizarGravacao(enviar: boolean): void {
    if (this.gravando) {
      if (enviar) this._enviarAoParar = true;
      this.pararGravacao();
      return;
    }

    if (enviar && this.audioFile) {
      this.aoGravar.emit(this.audioFile);
      this.fimGravacao.emit(true);
    }

    this.resetar();
  }

  descartarAudio(): void {
    this.resetar();
  }

  private resetar(limparTudo: boolean = true): void {
    this.pararTimer();
    this.gravando = false;
    this.chunks = [];
    this.stream?.getTracks().forEach(track => track.stop());
    this.stream = null;
    this.segundos = 0;
    this.tempoGravacao = '0:00';

    if (limparTudo) {
      this.audioBlob = null;
      this.audioFile = null;
      this.audioURL = null;
    }
    this.fimGravacao.emit(true);
  }

  pararGravacao(): void {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
  }

}
